import { render, staticRenderFns } from "./StoragePacksTab.vue?vue&type=template&id=36f27d51&scoped=true&"
import script from "./StoragePacksTab.vue?vue&type=script&lang=js&"
export * from "./StoragePacksTab.vue?vue&type=script&lang=js&"
import style0 from "./StoragePacksTab.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./StoragePacksTab.vue?vue&type=style&index=1&id=36f27d51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f27d51",
  null
  
)

export default component.exports